import React, { useEffect } from 'react';
import { BrowserRouter, Route, Switch, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import PrivateRoute from './PrivateRoute';
import Login from '@admin/login';
import AdminHome from '@admin/AdminHome';
import QuoteHome from '@quotes/QuoteHome';
import ReportHome from '@reports/ReportHome'
import GroupHome from '@groups/GroupHome';
import ScrollToTop from './ScrollToTop';
import ForgotPassword from '../ForgotPassword';
import Support from '../Support';

const RouterComponent = ({ logged_in, getAdminEvents }) => {
  const authed = logged_in;
  const history = useHistory();

  return (
    <BrowserRouter history={history} forceRefresh={false}>
      <ScrollToTop />
      <Switch>
        <Route path='/admin/login' exact component={Login} />
        <Route path='/support' exact component={Support} />
        <Route path='/forgot_password/:reset_token' component={ForgotPassword} />
        <PrivateRoute authed={authed} exact path='/admin' component={AdminHome} />
        <PrivateRoute authed={authed} exact path='/admin/quotes' component={QuoteHome} />
        <PrivateRoute authed={authed} exact path='/admin/reports' component={ReportHome} />
        <PrivateRoute authed={authed} exact path='/admin/groups' component={GroupHome} />
      </Switch>
    </BrowserRouter>
  )
}

const mapStatesToProps = (state) => {
  const { logged_in } = state.auth;
  return { logged_in };
};

export default connect(mapStatesToProps, {

})(RouterComponent);
